import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { PbxTrunkSchema } from "../../Schemas/PbxTrunk";

export interface PbxTrunkResponseBody extends IResponseBody {
  data: {
    pbx_trunks: PbxTrunkSchema[];
    total:number;
  };
}
interface Filter extends IFilterSchema {
  column: PbxTrunkListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: PbxTrunkListColumnSortable;
}

export enum PbxTrunkListColumnFilterable {
  ID = "id",
  CAPTION = "caption",
  DEPARTMENT = "department",
  TICKET_NUMBER = "ticket_number",
  STATUS = "status",
  PBX_SERVER_ID='pbx_server_id',
  UPDATED_AT = "updated_at",
}
export enum PbxTrunkListColumnSortable {
  ID = "id",
  CAPTION = "caption",
  DEPARTMENT = "department",
  TICKET_NUMBER = "ticket_number",
  STATUS = "status",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
}

export interface PbxTrunkListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

export class PbxTrunksListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/pbx-trunks`;
  }

  async get(
    queryStrings?: PbxTrunkListQueryString
  ): Promise<PbxTrunkResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
